import React from "react";
import "./style/portfolio.css";
import Ouimoove from "../assets/ouimoove.png";
import SampleManage from "../assets/sample-mange-app.png";
import Halloween from "../assets/halloween.png";
import ScrollApp from "../assets/scroll-app.png";
import HilExpertiz from "../assets/hilexpertiz.png";
import Galaxy from "../assets/animated-galaxy.png";
import InnoverAi from "../assets/innover-ai.png";
import IMG1 from "../assets/assie_ecommerce.webp";
import IMG2 from "../assets/nike_store.webp";
import IMG3 from "../assets/netflix_clone.webp";
import IMG4 from "../assets/task_mate.png";
import IMG5 from "../assets/task-app.png";
import IMG6 from "../assets/youtube-clone.webp";
import IMG7 from "../assets/pokedex.png";

function Portfolio() {
  const data = [
    {
      id: 1,
      image: Ouimoove,
      title: "Ticket sales",
      github: "https://github.com/Felix-fale",
      demo: "https://ouimoove.com/",
    },
    {
      id: 2,
      image: SampleManage,
      title: "Management App",
      github: "https://github.com/Felix-fale",
      demo: "https://sample-mange-app-falefelix.vercel.app/login",
    },
    {
      id: 3,
      image: Halloween,
      title: "Halloween Projet/ Threejs",
      github: "https://github.com/Felix-fale",
      demo: "https://halloween-falefelix.vercel.app/",
    },
    {
      id: 4,
      image: ScrollApp,
      title: "Moderne design",
      github: "https://github.com/Felix-fale",
      demo: "https://scroll-app-felix-fale.vercel.app/",
    },
    {
      id: 5,
      image: HilExpertiz,
      title: "HilExpertiz",
      github: "https://github.com/Felix-fale",
      demo: "https://hilexpertiz.africa/",
    },
    {
      id: 6,
      image: InnoverAi,
      title: "Innover avec l'IA",
      github: "https://github.com/Felix-fale",
      demo: "https://hilexpertiz.africa/ia",
    },
    {
      id: 7,
      image: Galaxy,
      title: "Theme galaxy / Threejs",
      github: "https://github.com/Felix-fale",
      demo: "https://animated-galaxy-final-falefelix.vercel.app/",
    },

    {
      id: 8,
      image: IMG1,
      title: "Ecommerce/ Fullstak FIREBASE",
      github: "https://github.com/Felix-fale",
      demo: "https://assie-felixfale.vercel.app/",
    },
    {
      id: 9,
      image: IMG2,
      title: "Modern Nike Store",
      github: "https://github.com/Felix-fale/nike-store",
      demo: "https://nike-store-felixfale.vercel.app/",
    },
    {
      id: 10,
      image: IMG3,
      title: "Netflix Clone",
      github: "https://github.com/Felix-fale/netflix-clone-v2",
      demo: "https://clone-netflix-felixfale.netlify.app/",
    },
    {
      id: 11,
      image: IMG4,
      title: "Chat app/FIREBASE",
      github: "https://github.com/Felix-fale/talk-mate",
      demo: "https://talkmate-falefelix.vercel.app/",
    },
    {
      id: 12,
      image: IMG5,
      title: "Task app/ MERN STACK",
      github: "https://github.com/Felix-fale/mern-task-app",
      demo: "https://mern-task-app.vercel.app/",
    },
    {
      id: 13,
      image: IMG6,
      title: "Youtube Clone",
      github: "https://github.com/Felix-fale/youtube-clone",
      demo: "https://youtube-clone-fale.netlify.app/",
    },
    {
      id: 14,
      image: IMG7,
      title: "Pokedex/API",
      github: "https://github.com/Felix-fale/typescript-pokedex",
      demo: "https://pokedex-fale-felix.netlify.app/",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, desc, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
              <div className="portfolio__item-cta">
                <a
                  href={github}
                  className="btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  Github
                </a>
                <a
                  href={demo}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Portfolio;
